<div class="rs-flex-row">
  <div class="rs-flex-column">
    <p class="rs-txt-s6 rs-txt-c2 rs-font-pxB">
      <span>{{ 'bills.summary.total' | translate }}</span>
    </p>
  </div>
  <div class="rs-flex-column rs-flex-shrink">
    <p class="text-right">
      <px-currency-amount
        [amount]="amount"
        [amountClass]="'rs-price-s rs-price-inverted'"
      ></px-currency-amount>
      <span class="rs-txt-c2" *ngIf="showVatText">
        <br />
        {{ 'bills.billCard.compactPriceText.vatIncl' | translate }}
      </span>
    </p>
  </div>
</div>
